import { jsx as _jsx } from "react/jsx-runtime";
import Stack from "@mui/material/Stack";
import { ContactFetchCheckListItem } from "../ContactFetchCheckListItem";
export var ContactCheckList = function (_a) {
    var _b = _a.contactIds, contactIds = _b === void 0 ? [] : _b, handleSelectContact = _a.handleSelectContact, getSubtitle = _a.getSubtitle;
    return (_jsx(Stack, { direction: "column", gap: 1, children: contactIds.map(function (contactId) { return (_jsx(ContactFetchCheckListItem, { contactId: contactId, handleSelectContact: handleSelectContact, getSubtitle: getSubtitle })); }) }));
};
